import './App.css';
import React from 'react';
import MOTKPAGE from './GamePages/Mark_Of_the_Knights_page';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import WorkInProg from './GamePages/WorkInProgressPage';


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<WorkInProg/>} />
        <Route path="/MOTK" element ={<MOTKPAGE/>}/>
      </Routes>
    </Router>
  );
}

export default App;
